// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  LocalizableString,
} from "./types";


export default __t.row({
  id: __t.u64().primaryKey(),
  parentDtmi: __t.string().name("parent_dtmi"),
  name: __t.string(),
  schemaDtmi: __t.string().name("schema_dtmi"),
  get displayName() {
    return LocalizableString.name("display_name");
  },
  comment: __t.option(__t.string()),
  get description() {
    return LocalizableString;
  },
});
